import { getAuthorizationUri } from '../services/getAuthorizationUri';
export function connectGmail() {
    var height = 700;
    var width = 600;
    var top = (window.screen.height - height) / 2;
    var left = (window.screen.width - width) / 2;
    var gmailWindow = window.open('', '_blank', "width=" + width + ",height=" + height + ",top=" + top + ",left=" + left + ",menubar=no,status=no,scrollbars=no,titlebar=no,toolbar=no,resizable=yes");
    getAuthorizationUri().then(function (response) {
        if (!response.ErrorMessage) {
            gmailWindow.location.href = response.OAuth2AuthorizationEndpointInfo.AuthorizationUri;
        }
    });
}
//# sourceMappingURL=connectGmail.js.map